
function GridItem(props) {
  const { data } = props;
  console.log(data)

  return (
    <>
      <div className="grid-item">
        <a href={data.link_url} className="slot">
          {data.image_url &&
            <div className="slot-image">
              <img
                sizes="(min-width: 1980px) 655px, (min-width: 1040px) calc(31.63vw + 35px), (min-width: 780px) 39.58vw, 89.35vw"
                srcset={data.image_srcset}
                src={data.image_url}
                alt={data.image_alt} />
              {data.slot_tags &&
                <div class="tags"> {

                  data.slot_tags.map(tag =>
                    <div className="tag">{tag.name}</div>
                  )
                }

                </div>
              }

            </div>
          }
          <div className="slot-content">
            {data.title &&
              <h3 className="slot-title font-25-25">{data.title}</h3>
            }


            {data.text &&
              <div className="slot-text">{data.text}</div>
            }




          </div>


        </a>
      </div >
    </>
  )
}

export default GridItem;
